/*
 * Шаблон ответа на тикет (canned reply). Используется в TicketReplyForm —
 * оператор выбирает шаблон, текст вставляется в черновик, переменные подставляются
 * из текущего тикета.
 *
 * Видимость: общая в рамках организации. Никаких per-user/per-branch шаблонов.
 * Языки: отдельная запись на каждый язык (RU/KK/EN), без переводов внутри одной.
 */
export interface ResponseTemplate {
    id: string;
    orgID: string;
    title: string;
    content: string;
    language: ResponseTemplateLanguage;
    createdByID: string | null;
    createdAt: string;
    updatedAt: string;
}

export enum ResponseTemplateLanguage {
    RU = 'RU',
    KK = 'KK',
    EN = 'EN',
}

export const RESPONSE_TEMPLATE_LANGUAGES: ResponseTemplateLanguage[] = [
    ResponseTemplateLanguage.RU,
    ResponseTemplateLanguage.KK,
    ResponseTemplateLanguage.EN,
];

export const RESPONSE_TEMPLATE_LANGUAGE_LABELS: Record<ResponseTemplateLanguage, string> = {
    [ResponseTemplateLanguage.RU]: 'Русский',
    [ResponseTemplateLanguage.KK]: 'Қазақша',
    [ResponseTemplateLanguage.EN]: 'English',
};
